<app-header></app-header>
<section class="bredcrumb">
  <div class="container">
      <ul class="brd-nav">
          <li> <a [routerLink]="['/']"> Home </a></li>
          <li> <a [routerLink]="['/hospitals/list']"> Hospitals </a></li>
          <li> <span> {{ hospitalDetail.name }} </span></li>
      </ul>
  </div>
</section>
<!--- End of bredcrumb -->

<section class="single-page hospitals-detail labs-detail doctors-detail padd-row">
  <div class="container">
      <div class="row">
          <div class="col-lg-4">
              <div style="cursor:pointer" (click)="showImagePopup(hospitalDetail.coverPhoto)"  class="hospital-img">
                  <img [src]="hospitalDetail.coverPhoto" alt="image">
              </div>
              <div class="doc-detail-lft grey-bg sidebar">
                  <div class="hos-detail-cnt-top-sidebar btm-line">
                      <h2> {{ hospitalDetail?.name }}  </h2>
                      <div class="hos-detail-rating-sidebar">
    <i class="fa fa-star"  *ngFor='let in of counter( parseInt(hospitalDetail?.averageRatings)) ;let i = index' aria-hidden="true"></i>
    <i class="fa fa-star-o" *ngFor='let in of counter( 5 - parseInt(hospitalDetail?.averageRatings)) ;let i = index' aria-hidden="true"></i>
                          <!-- <i class="fa fa-star" aria-hidden="true"></i>
                          <i class="fa fa-star" aria-hidden="true"></i>
                          <i class="fa fa-star" aria-hidden="true"></i>
                          <i class="fa fa-star" aria-hidden="true"></i>
                          <i class="fa fa-star" aria-hidden="true"></i> -->
                          <span> {{ hospitalDetail?.averageRatings | number:'1.0-2' }} </span>
                          <p> {{ hospitalDetail?.review?.length }} Reviews </p>
                      </div>
                  </div>
                  <div class="hos-detail-adrs-top-sidebar btm-line">
                      <p> <strong> Address </strong></p>
                      <p><a target="_blank" [href]="'https://www.google.com/maps/place/'+hospitalDetail?.address"> <i class="fa fa-map-marker" aria-hidden="true"></i>{{ hospitalDetail?.address }}</a>  </p>
                      <p> <strong> Fees </strong></p>
                      <p> Rs. {{ hospitalDetail?.fees }}/- </p>
                      <p> <strong> Phone Number </strong></p>
                      <p> {{ hospitalDetail?.phoneNo }}  {{ hospitalDetail?.alternateNumber ? '| '+hospitalDetail?.alternateNumber : ''  }} </p>
                      <p> <strong> Website </strong></p>
                      <p> {{ hospitalDetail?.website }}</p>
                  </div>
                  <div class="doc-detail-btm">
                    <!-- <ul>
                        <li>  <a target="_blank" [href]="'https://www.google.com/maps/place/'+doctorDetail.address"> <i class="fa fa-map-marker" aria-hidden="true"></i> {{ doctorDetail.address }}</a></li>
                        <ng-template [ngIf]="availability.length>0" #avilability>
                        
                          <li [ngStyle]="{ 'color': single.error ? 'red' : 'none' }" [hidden]="single?.timing==''" *ngFor="let single of availability"> <i [ngStyle]="{ 'color': single.error ? 'red' : '#26abe3' }"  class="fa fa-calendar-check-o" aria-hidden="true"></i> {{ single.timing }} </li>
                        </ng-template>
                    </ul> -->
                    <a style="color:#fff;" routeeLinnk="null" (click)="Booking(true)" *ngIf="hospitalDetail?.treatments?.length>0" class="btn-style"> Book Appointment </a>
                </div>
                  <!-- <div *ngIf="hospitalDetail?.images?.length>0" class="labs-details-images btm-line">
                      <h3> Images </h3>
                      <ul class="clearfix">
                          <li *ngFor="let image of hospitalDetail?.images"> <img [src]="image" alt="image"> </li>
                      
                      </ul>
                  </div> -->
                  <div class="date-slider-box">
                    <!-- <ul class="date-slider"> -->
                          <ngx-slick-carousel  class="carousel"
                          #slickModal="slick-carousel"
                          [config]="slideConfig">
                        <div ngxSlickItem class="slide" (click) ="getSlots(oneDate,i)" *ngFor="let oneDate of showDateWithDay let i=index">
                            <h4 [ngClass]="oneDate.selected ? 'selected' : '' "> {{ oneDate.day }} <span> {{ oneDate.showdate }}</span></h4>
                        </div>
                      </ngx-slick-carousel>
                       
                    <!-- </ul> -->
                </div>
                <div class="doc-details-timing">
                    <div id="accordion" class="accordion">
                        <div class="card mb-0">
                            <div *ngIf="morningSlots.length>0" class="card-header" data-toggle="collapse" href="#date1">
                                <a class="card-title"> Morning </a>
                            </div>
                            <div id="date1" *ngIf="morningSlots.length>0" class="card-body collapse show" data-parent="#accordion">
                              <ul >
                                    <li *ngFor="let slot of morningSlots" (click)="timeSet(slot.status,slot.sendTime,slot)" [ngClass]="{'grey': slot.status, 'selected':slot.selected }"> {{ slot.time }} </li>
                                  
                                    </ul>
                            </div>
                            <div *ngIf="afterNoonSlots.length>0" class="card-header collapsed" data-toggle="collapse" data-parent="#accordion" href="#date2">
                                <a class="card-title"> Afternoon </a>
                            </div>
                            <div *ngIf="afterNoonSlots.length>0" id="date2" class="card-body collapse" data-parent="#accordion">
                                <ul>
                                    <li *ngFor="let slot of afterNoonSlots" (click)="timeSet(slot.status,slot.sendTime,slot)" [ngClass]="{'grey': slot.status, 'selected':slot.selected }"> {{ slot.time }}  </li>
                                  
                                </ul>
                            </div>
                            <div *ngIf="eveningSlots.length>0" class="card-header collapsed" data-toggle="collapse" data-parent="#accordion" href="#date3">
                                <a class="card-title"> Evening </a>
                            </div>
                            <div *ngIf="eveningSlots.length>0" id="date3" class="collapse" data-parent="#accordion">
                                <ul>
                                    <li  *ngFor="let slot of eveningSlots" (click)="timeSet(slot.status,slot.sendTime,slot)" [ngClass]="{'grey': slot.status, 'selected':slot.selected }"> {{ slot.time }}  </li>
                                    
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="startTimeError" class="alert alert-danger">Please select a slot for appointment </div>
                </div>
                  <div *ngIf="hospitalDetail?.treatments.length>0" class="doc-deatils-treatments">
                    <h4> Select Treatments </h4>
                    <ul>
                        <li *ngFor="let treatment of hospitalDetail.treatments let i=index" class="clearfix">
                            <div class="doc-details-treats-lft-cnt"> {{ treatment.name }}</div>
                            <form class="doc-details-treats-rght-cnt">
                                <span class="cut-price" *ngIf="hospitalDetail.discount!=0"> {{ treatment.price }} </span>
                                <span class="price" [innerHTML]="getPriceAfterDiscount(treatment.price,hospitalDetail.discount)" > </span>
                                <input type="checkbox" [checked]="findAlreadyAdded(treatment)" (change)="onCheckboxChange(treatment,$event)"   class="form-control">
                            </form>
                        </li>
                        
                    </ul>
                    <div *ngIf="treatmentError" class="alert alert-danger">Please select atleast one treatment</div>
                </div>
                <div *ngIf="hospitalDetail?.images.length>0" class="labs-details-images btm-line">
                        <h3> Images </h3>
                        <ul class="clearfix">
                          <li (click)="showImages()" *ngFor="let image of hospitalDetail?.images"><img [src]="image" alt="image"></li>
                       
                        </ul>
                      </div>
                  <div *ngIf="hospitalDetail?.review?.length>0" class="labs-reviews-sum">
                      <h3> Review Summary </h3>
                      <div class="labs-reviews-sum-prgs-bar">
                        <div class="lab-reviws-prgs-box">
                            <label> 5 </label>
                            <div class="progress">
                                <div class="progress-bar" [style.width]="hospitalDetail.starsCount_Five+'%'"></div>
                            </div>
                        </div>
                        <div class="lab-reviws-prgs-box">
                            <div class="progress">
                                <label> 4 </label>
                                <div class="progress-bar" [style.width]="hospitalDetail.starsCount_Four+'%'"></div>
                            </div>
                        </div>
                        <div class="lab-reviws-prgs-box">
                            <div class="progress">
                                <label> 3 </label>
                                <div class="progress-bar" [style.width]="hospitalDetail.starsCount_Three+'%'"></div>
                            </div>
                        </div>
                        <div class="lab-reviws-prgs-box">
                            <div class="progress">
                                <label> 2 </label>
                                <div class="progress-bar" [style.width]="hospitalDetail.starsCount_Two+'%'"></div>
                            </div>
                        </div>
                        <div class="lab-reviws-prgs-box">
                            <div class="progress">
                                <label> 1 </label>
                                <div class="progress-bar" [style.width]="hospitalDetail.starsCount_One+'%'"></div>
                            </div>
                        </div>
                    </div>
                  </div>
              </div>
          </div>

          <div class="col-lg-8">

                <div class="doc-detail-nav">
                        <ul class="nav nav-pills">
                            <li class="nav-item">
                                <a class="nav-link active" data-toggle="pill" (click)="scroll(target)" href="#doc-details-1"> About </a>
                            </li>
                         
                            <li *ngIf="hospitalDetail?.services?.length>0" class="nav-item">
                                <a class="nav-link" data-toggle="pill" (click)="scroll(target2)" href="#doc-details-3"> Services </a>
                            </li>

                            <li *ngIf="hospitalDetail?.doctors?.length>0" class="nav-item">
                                    <a class="nav-link" data-toggle="pill" (click)="scroll(target3)" href="#doc-details-4"> Doctors </a>
                                </li>
                                <li *ngIf="hospitalDetail?.ambulance?.length>0" class="nav-item">
                                        <a class="nav-link" data-toggle="pill" (click)="scroll(target4)" href="#doc-details-5"> Ambulances </a>
                                    </li>
                            
                            <li *ngIf="hospitalDetail?.blogs?.length>0" class="nav-item">
                                <a class="nav-link" data-toggle="pill" (click)="scroll(target5)" href="#doc-details-6"> Blogs </a>
                            </li>
                            <li *ngIf="hospitalDetail?.review?.length>0" class="nav-item">
                                <a class="nav-link" data-toggle="pill"  (click)="scroll(target7)" href="#doc-details-7"> Reviews </a>
                            </li>
                        </ul>
                    </div>




              <div class="doc-detail-right tab-content">

                    <div #target class="tab-pane active" id="doc-details-1j">
                            <div class="doc-detail-right-main">
                                <div class="doc-detail-cnt pt-0 btm-line">
                                    <h3> About </h3>
                                    <p class="mb-0">{{ hospitalDetail?.description }} </p>
                                </div>
                                       
                             
                            </div>
                        </div>

                        <div #target2 id="doc-details-3j">
                                <div *ngIf="hospitalDetail?.services?.length>0" class="doc-detail-right-main">
                                   
                                  <div class="doc-detail-right-list doc-detail-cnt btm-line">
                                      <h3> Services </h3>
                                      <ul>
                                          <li *ngFor="let service of hospitalDetail?.services"> {{ service }} </li>
                                          <!-- <li>Aesthetic Crown And Bridges </li>
                                          <li>Bleaching</li>
                                          <li>Artificial Teeth</li>
                                          <li>Ceramic Crowns</li>
                                          <li>Conscious Sedation </li>
                                          <li>Conservative Dentistry </li> -->
                                      </ul>
                                      <ul>
                                          
                                          <!-- <li>Aesthetic Crown And Bridges </li>
                                          <li>Bleaching</li>
                                          <li>Artificial Teeth</li>
                                          <li>Ceramic Crowns</li>
                                          <li>Conscious Sedation </li>
                                          <li>Conservative Dentistry </li> -->
                                      </ul> 
                                  </div>
                                  
                                </div>
                            </div>

                            <div #target3 id="doc-details-4j">
                  <div *ngIf="hospitalDetail?.doctors.length>0" class="hospital-detail-rght-doc">
                      <div  class="hospital-detail-head mt-0">
                          <div class="d-md-flex">
                              <h3> Doctors </h3>
                              <!-- <a [routerLink]="['/doctors/list']"> View All </a> -->
                          </div>
                      </div>
                      <div class="hospital-detail-doc-body">
                          <div  class="row">
                              <div class="col-md-3" *ngFor="let doctor of hospitalDetail.doctors">
                                  <div class="doctor-box">
                                      <div class="doctor-box-top">
                                          <div class="doctor-box-img">
                                              <img [src]="doctor.profilePicture" alt="image">
                                          </div>
                                          <div class="doctor-box-top-cnt">
                                              <div class="doctor-box-rating">
                                                  <i class="fa fa-star" aria-hidden="true"></i> <span>  {{ doctor?.averageRatings ? doctor?.averageRatings : '0' }} /5 </span>
                                                  <p> {{ doctor?.review?.length }} Reviews </p>
                                              </div>
                                          </div>
                                      </div>
                                      <div class="doctor-box-btm">
                                          <h5>  {{ doctor?.name }} <span> {{ doctor?.education?.join(' | ') }} </span></h5>
                                          <!-- <p> Reg. No : {{ doctor.registrationNo }} </p> -->
                                          <p>Registered Doctor <img style="width:30px;height:30px" src="assets/images/bluetick.png"></p>
                                          <a [routerLink]="['/hospitals/doctor-detail/'+doctor.uniquekey]" class="btn-style btn-style-border"> View Profile </a>
                                      </div>
                                  </div>
                              </div>
                             
                          </div>
                      </div>
                  </div>
                            </div>
                            <div #target4 id="doc-details-5j">
                  <div *ngIf="hospitalDetail?.ambulance?.length>0" class="ambulance-detail-rght-doc">
                      <div class="hospital-detail-head">
                          <div class="d-md-flex">
                              <h3> Ambulances </h3>
                              <!-- <a href="javascript://"> View All </a> -->
                          </div>
                      </div>
                      <div class="ambulance-detail-rght-body">
                          <div class="row">
                              <div *ngFor="let ambulance of hospitalDetail.ambulance" class="col-md-6">
                                  <div class="ambulance-detail-box doctor-box">
                                      <div class="doctor-box-top">
                                          <div class="doctor-box-img">
                                              <img [src]="ambulance.profilePicture" alt="image">
                                          </div>
                                          <div class="doctor-box-top-cnt">
                                              <div class="d-md-flex">
                                                  <h5> {{ ambulance.vehicleNo }} <span>
                                                       <!-- Reg. No : {{ ambulance.registrationNo }} -->
                                                       Registered Ambulance
                                                       <img style="width:30px;height:30px" src="assets/images/bluetick.png"> 
                                                     </span></h5>
                                                  <div class="doctor-box-rating">
                                                      <i class="fa fa-star" aria-hidden="true"></i> <span>  {{ ambulance.rating }}/5 </span>
                                                      <!-- <p>  {{ ambulance.review }} Reviews </p> -->
                                                  </div>
                                              </div>
                                              <div class="doc-box-adrs">
                                                  <p> Basic Life Support </p>
                                                  <p> Phone : <a [routerLink]="null"> {{ ambulance.phoneNo }} </a></p>
                                                  <!-- <a href="" data-toggle="modal" (click)="getCurrentLocation()" 
                                                  data-target="#emergency-book" class="btn-style btn-style-border"> Book </a> -->
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              
                          </div>
                      </div>
                  </div>
                            </div>
                            <div #target5 id="doc-details-6j">
                  <div  *ngIf="hospitalDetail?.blogs?.length>0" class="doc-detail-health-blogs-doc">
                      <div class="hospital-detail-head">
                          <div class="d-md-flex">
                              <h3> Blogs </h3>
                              <a [routerLink]="['articles/yoga']"> View All </a>
                          </div>
                      </div>
                      <div class="doc-detail-health-blogs">
                          <a *ngFor="let blog of hospitalDetail?.blogs" [routerLink]="['/blog-detail/'+blog?.uniquekey]" > <img [src]="blog?.image"> </a>
                        
                      </div>
                  </div>
                             </div>
                             <div  #target7  id="doc-details-7">
                                <div *ngIf="hospitalDetail?.review?.length>0" class="doc-detail-right-main">
          
          
                                    <div class="doc-detail-client-reviews doc-detail-cnt">
                                        <h3> Reviews </h3>
                                        <section class="our-customers">
                                        <div class="our-customers-main">
                                        <ngx-slick-carousel class="carousel"
                                        #slickModal4="slick-carousel"
                                        [config]="slideConfigCustomers"
                    >
                   
                          <div *ngFor="let review of hospitalDetail?.review" ngxSlickItem class="slider">
                      <div class="our-customers-box_phar">
                          <div class="client-review-box-img_phar">
                              <img [src]="review?.userId?.profilePicture ? review?.userId?.profilePicture : 'https://previews.123rf.com/images/tuktukdesign/tuktukdesign1605/tuktukdesign160500002/57495136-user-icon-laptop-computer-device-worker-icon-in-illustration-.jpg'" alt="image">
                          </div>
                          <div class="client-review-box-cnt_phar">
                              <h5> {{ review?.userId?.name }} </h5>
                              <p> "{{ review?.comment }}"</p>
                              <i *ngFor='let in of counter(review?.stars) ;let i = index' class="fa fa-star" aria-hidden="true"></i>
                                        <i class="fa fa-star-o"   *ngFor='let in of counter(5- review?.stars) ;let i = index'  aria-hidden="true"></i> 
                             
                              <span> {{ !review.stars ? 0 : review.stars }} </span>
                          </div>
                          <!--div class="doctor-box-rating">
                                <i *ngFor='let in of counter(review?.stars) ;let i = index' class="fa fa-star" aria-hidden="true"></i>
                                        <i class="fa fa-star-o"   *ngFor='let in of counter(5- review?.stars) ;let i = index'  aria-hidden="true"></i> 
                             
                              <span> {{ !review.stars ? 0 : review.stars }} </span>
                             
                          </div-->
                      </div>
                           </div>
                  
                  </ngx-slick-carousel>
                  </div>
                  </section>
                                      
                                      </div>
                                </div>
                            </div>
              </div>
          </div>
      </div>
  </div>
</section>
<!-- End of doctors-detail -->
<input type="hidden" id="loginEmergency" data-target="#emergency-book" data-toggle="modal" >


<div class="modal fade" id="emergency-book">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
      
            <!-- Modal body -->
            <div class="modal-body">
              <div class="sign-up-form emgergency-form">
                <h2 class="text-center"><span> Book a Ambulance </span></h2>
                <form action="ambulance-tracking.html">
                  <div class="row">
                    <div class="col-md-12">
                      <label> Enter Your Location </label>
                      <div class="form-group-main">
                        <input type="text" ngx-google-places-autocomplete
                               #placesRef="ngx-places"
                               (onAddressChange)="handleAddressChange($event)"
                               #place class="form-control" name="locationAddress" [options]='options'
                               [(ngModel)]="bookObject.address" placeholder="Chandigarh...">
      
                        <img src="assets/images/location.png" alt="image">
                      </div>
                    </div>
                    <div class="col-md-12">
                      <label> Enter Your Name </label>
                      <div class="form-group-main">
                        <input type="text" class="form-control" name="userName" [(ngModel)]="bookObject.name"
                               placeholder="David Miller">
                        <img src="assets/images/form-user.png" alt="image">
                      </div>
                    </div>
                    <div class="col-md-12">
                      <label> Enter Phone Number </label>
                      <div class="form-group-main">
                        <input type="number" class="form-control" name="phoneNobook" [(ngModel)]="bookObject.phoneNo"
                               placeholder="+91 9876543210">
                        <img src="assets/images/phone.png" alt="image">
                      </div>
                    </div>
                    <div class="col-md-12">
                      <input *ngIf="isLoggedIn" type="submit" value="Book Now" (click)="bookAmbulance(true)"
                             class="btn-style">
                      <input *ngIf="!isLoggedIn" type="submit" value="Book Now" (click)="bookAmbulance_without_login()"
                             class="btn-style">
                      <a style="display:none;" routerLink="" data-toggle="modal" id="booking_otp_trigger"
                         data-target="#booking_otp"></a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="modal fade" id="booking_otp">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
      
            <!-- Modal body -->
            <div class="modal-body">
              <div class="sign-up-form login-form">
                <!-- <h2 class="text-center"> <span>Enter Verification Code </span> to Book Ambulance </h2> -->
                <div id="booking-otp">
                  <h2 class="text-center"><span> Verification Code </span></h2>
                  <form action="user.html">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="login-mob-img">
                          <img src="assets/images/login-mob-img-otp.jpg" alt="image">
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="login-otp-recived">
                          <h5> Otp has been send to <span> {{ bookObject.phoneNo }} </span></h5>
                          <div class="otp-input-group">
      
                            <!-- <input *ngFor="let obj of otpValObjUser" type="text" maxlength="1" (keypress)="numberOnly($event,obj.arg)"  [name]="obj.name" [(ngModel)]="obj.model" [id]="obj.id" class="form-control"> -->
                            <input type="text" maxlength="1" (keypress)="numberOnly($event,'next_booking')" name="otp2"
                                   [(ngModel)]="otpValObj1_booking" class="form-control">
                            <input type="text" maxlength="1" (keypress)="numberOnly($event,'next1_booking')" id="next_booking"
                                   name="otp2" [(ngModel)]="otpValObj2_booking" class="form-control">
                            <input type="text" maxlength="1" (keypress)="numberOnly($event,'next2_booking')"
                                   id="next1_booking" name="otp3" [(ngModel)]="otpValObj3_booking" class="form-control">
                            <input type="text" maxlength="1" (keypress)="numberOnly($event,null)" id="next2_booking"
                                   name="otp4" [(ngModel)]="otpValObj4_booking" class="form-control">
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <input type="submit" value="Book Ambulance" (click)="checkOtpfuncUserBookingLogin()"
                               class="btn-style">
                        <div *ngIf="verifyOtpError_Booking" style="color:red">Otp does not match</div>
                        <div class="resend-otp">
                          <a [routerLink]="['']" (click)="resendOtp()"> Resend OTP </a>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
      
              </div>
            </div>
          </div>
        </div>
      </div>



      
      <input type="hidden" id="orderImagesCLick" data-toggle="modal" data-target="#orderImagesModal">

      <!-- The Modal -->
      <div class="modal fade"  id="orderImagesModal">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Image Preview</h5>
            </div>
            <!-- Modal body -->
            <div class="modal-body text-center">
                  <slideshow
                  [minHeight]="'525px'"
                  [showArrows]="imageUrlArray.length>1 ? true : false"
                  [imageUrls]="imageUrlArray"></slideshow>
              <button class="btn btn-primary" style="margin-top: 20px;"
       data-toggle="modal" data-target="#orderImagesModal">OK</button>
      
            </div>
          </div>
        </div>
      </div>
      



      <input type="hidden" data-toggle="modal"
      data-target="#treatment_popup" id="treatment_popup_trigge_doctor" >
      
      
      
      <div class="modal fade payment-booking-modal booking-popup-new-setup" id="treatment_popup">
          <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
      
                  <!-- Modal body -->
                  <div class="modal-body">
      
      
      <div class="doc-deatils-treatments">
          <h4> Select Treatments </h4>
          <ul>
              <li *ngFor="let treatment of hospitalDetail?.treatments let i=index" class="clearfix">
                  <div class="doc-details-treats-lft-cnt"> {{ treatment.name }}</div>
                  <form class="doc-details-treats-rght-cnt">
                      <span class="cut-price" *ngIf="hospitalDetail.discount!=0"> {{ treatment.price }} </span>
                      <span class="price" [innerHTML]="getPriceAfterDiscount(treatment.price,hospitalDetail.discount)" > </span>
                      <input type="checkbox" [checked]="findAlreadyAdded(treatment)"  (change)="onCheckboxChange(treatment,$event)"   class="form-control">
                     
                  </form>
              </li>
              
          </ul>
      </div>
      <div class="text-right">
      <button class="btn btn-style" (click)="Booking(false)" [disabled]="sendBookingData.treatments.length==0" 
      >Next</button>
      </div>
      
      </div>
      </div>
      </div>
      </div>
      
      
      
      
      <input type="hidden" data-toggle="modal"
      data-target="#slot_popup" id="slot_popup_trigge_doctor" >
      
      <div class="modal fade payment-booking-modal booking-popup-new-setup" id="slot_popup">
          <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
                  <!-- Modal body -->
                  <div class="modal-body">
      
      <div class="doc-details-timing">
          <div id="accordion_popup" class="accordion">
              <div class="card mb-0">
                  <div *ngIf="morningSlots.length>0" class="card-header" data-toggle="collapse" href="#date1_popup" aria-expanded="false">
                      <a class="card-title"> Morning </a>
                  </div>
                  <div *ngIf="morningSlots.length>0" id="date1_popup" class="card-body collapse" data-parent="#accordion_popup" style="">
                      <ul>
                          <li *ngFor="let slot of morningSlots" (click)="timeSet(slot.status,slot.sendTime,slot)" [ngClass]="{'grey': slot.status, 'selected':slot.selected }"> {{ slot.time }} </li>
                      </ul>
                  </div>
                  <div *ngIf="afterNoonSlots.length>0" class="card-header" data-toggle="collapse" data-parent="#accordion_popup" href="#date2_popup" aria-expanded="false">
                      <a class="card-title"> Afternoon </a>
                  </div>
                  <div *ngIf="afterNoonSlots.length>0" id="date2_popup" class="card-body collapse" data-parent="#accordion_popup" style="">
                      <ul>
                          <li *ngFor="let slot of afterNoonSlots" (click)="timeSet(slot.status,slot.sendTime,slot)" [ngClass]="{'grey': slot.status, 'selected':slot.selected }"> {{ slot.time }}  </li>
                      </ul>
                  </div>
                  <div *ngIf="eveningSlots.length>0" class="card-header" data-toggle="collapse" data-parent="#accordion_popup" href="#date3_popup" aria-expanded="false">
                      <a class="card-title"> Evening </a>
                  </div>
                  <div *ngIf="eveningSlots.length>0" id="date3_popup" class="collapse" data-parent="#accordion_popup" style="">
                      <ul>
                          <li  *ngFor="let slot of eveningSlots" (click)="timeSet(slot.status,slot.sendTime,slot)" [ngClass]="{'grey': slot.status, 'selected':slot.selected }"> {{ slot.time }}  </li>
                      </ul>
                  </div>
              </div>
          </div>
      </div>
      <div class="text-right">
          <button class="btn btn-style" [disabled]="sendBookingData.startTime==0" (click)="showTreatPopup()" >Next</button>
          <button class="btn btn-style btn-style-grey ml-1" (click)="closeSlotPopup()" >Cancel</button>
      </div>
      </div>
      </div>
      </div>
      </div>


      <input type="hidden" data-toggle="modal"
      data-target="#book-appiontment_doctor" id="booking_doctor_trigge_doctor" >
      
      <div class="modal fade payment-booking-modal" id="book-appiontment_doctor">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
    
                <!-- Modal body -->
                <div class="modal-body">
                    <div class="sign-up-form payment-form">
                        <div id="payment-screen-1">
                            <div class="doc-detail-box">
                                <div class="doctor-box-top">
                                    <div class="doctor-box-img">
                                        <img [src]="hospitalDetail.coverPhoto" alt="image">
                                    </div>
                                    <div class="doctor-box-top-cnt">
                                        <h5>  {{ hospitalDetail?.name }} <span> Appointment Booking  </span></h5>
                                        <div *ngIf="hospitalDetail.averageRatings" class="doctor-box-rating">
                                            <i *ngFor='let in of counter( parseInt(hospitalDetail.averageRatings)) ;let i = index' class="fa fa-star" aria-hidden="true"></i>
                                            <i class="fa fa-star-o"   *ngFor='let in of counter(5- parseInt(hospitalDetail.averageRatings)) ;let i = index'  aria-hidden="true"></i> 
                                            <span> {{ hospitalDetail.review?.length }} Reviews </span>
                                          
                                        </div>
                                    </div>
                                </div>
                                <div class="doc-detail-btm">
                                    <div class="doc-adrs-details-modal">
                                        <div class="d-md-flex">
                                            <p> <strong> Appointment Date & Time </strong> {{ bookingDay }} | {{ sendBookingData.bookingDate }} | {{ sendBookingData.startTime }} </p>
                                            <p class="doc-adrs-rght-details-modal"> <strong> Treatment </strong> {{ sendTreatments }} </p>
                                        </div>
                                        <div class="d-md-flex">
                                            <p> <strong> Total Amount: </strong>  </p>
                                            <!-- <p class="doc-adrs-rght-details-modal"> <strong> Email </strong> rishabhjain@gmail.com </p> -->
                                            <p class="doc-adrs-rght-details-modal"> <strong> {{ totalAmount==0 ? 'Free' : 'Rs.' + totalAmount + '/-' }}  </strong>  </p>
                                        </div>
                                    </div>
                                    <input type="button" (click)="payWithRazor()" class="btn-style" id="open-payment-screen-2" value="Proceed to Payment">   
                                    <input type="button"  class="btn-style mt-0 btn-style-grey" data-dismiss="modal" value="Cancel">   
                                </div>
                            </div>
                        </div>
                        <div id="payment-screen-2" style="display: none;">
                            <div class="payment-screen-2">
                                <div class="row no-gutters">
                                    <div class="col-md-4">
                                        <div class="payment-method">
                                            <h3> Payment Methods </h3>
                                            <div class="payment-method-nav">
                                                <ul class="nav nav-pills">
                                                    <li class="nav-item">
                                                        <a class="nav-link active" data-toggle="pill" href="#payment-method-1"> Debit cards </a>
                                                    </li>
                                                    <li class="nav-item">
                                                        <a class="nav-link" data-toggle="pill" href="#payment-method-2"> Credit Cards </a>
                                                    </li>
                                                    <li class="nav-item">
                                                        <a class="nav-link" data-toggle="pill" href="#payment-method-3"> Net Banking </a>
                                                    </li>
                                                    <li class="nav-item">
                                                        <a class="nav-link" data-toggle="pill" href="#payment-method-4"> Paypal </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="payment-method-desc">
                                            <div class="tab-content">
                                                <div class="tab-pane active" id="payment-method-1">
                                                    <div class="payment-method-desc-navs">
                                                        <ul class="nav nav-pills">
                                                            <li class="nav-item">
                                                                <a class="nav-link active" data-toggle="pill" href="#add-card"> Add New Card </a>
                                                            </li>
                                                            <li class="nav-item">
                                                                <a class="nav-link" data-toggle="pill" href="#save-card"> Saved Cards </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="payment-method-desc-cnt">
                                                        <div class="tab-content">
                                                            <div class="tab-pane active" id="add-card">
                                                                <form>
                                                                    <div class="row">
                                                                        <div class="col-md-12">
                                                                            <input type="text" class="form-control" placeholder="Card Number">
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <input type="text" class="form-control" placeholder="Expired on">
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <input type="text" class="form-control" placeholder="CVV">
                                                                        </div>
                                                                        <div class="col-md-12">
                                                                            <input type="text" class="form-control" placeholder="Card Holder Name">
                                                                        </div>
                                                                        <div class="col-md-12">
                                                                            <input type="submit" class="btn-style" value="Pay Rs. 500/-">
                                                                        </div>
    
                                                                    </div>
                                                                </form>
                                                            </div>
                                                            <div class="tab-pane" id="save-card">
                                                                <form>
                                                                    <div class="row">
                                                                        <div class="col-md-12">
                                                                            <input type="text" class="form-control" placeholder="Card Number">
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <input type="text" class="form-control" placeholder="Expired on">
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <input type="text" class="form-control" placeholder="CVV">
                                                                        </div>
                                                                        <div class="col-md-12">
                                                                            <input type="text" class="form-control" placeholder="Card Holder Name">
                                                                        </div>
                                                                        <div class="col-md-12">
                                                                            <input type="submit" class="btn-style" value="Pay Rs. 500/-">
                                                                        </div>
    
                                                                    </div>
                                                                </form>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="tab-pane fade" id="payment-method-2">...</div>
                                                <div class="tab-pane fade" id="menupayment-method-3">...</div>
                                                <div class="tab-pane fade" id="payment-method-4">...</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
    
    
    
                            </div>
    
                        </div> 
                    </div>
                </div>
            </div>
        </div>
    </div>
 




   